import styled from 'styled-components';

export const ButtonAux = styled.div`
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
cursor: pointer;
margin: 0px 0px 0px 0px;
align-self: end;
gap: 8px;
font-family: 'Montserrat',sans-serif;
font-weight: 700;
font-size: 12px;
color: #07082c;
padding: 4px 8px;
display: flex;
flex-direction: row;
align-items: center;
padding: 5px;
height: auto;
border-radius: 8px;
width: auto;
min-width: max-content;
&:focus {
  outline: none;
}
&:hover {
  transition: all 0.1s linear;
  filter: opacity(0.5);
  box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
}
&:active {
  transform:scale(0.90)
}
`;

export const VideoCont = styled.video`
border-radius: 8px;
height: auto;
width: 50%;
margin: 15%;
`;

export const DivBoxContainer = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
width: -webkit-fill-available;
height: auto;
justify-content: center;
`;

export const DivContentFilters = styled.div`
width: 25vw;
min-width:280px;
max-width: 350px;
height: auto;
min-height: 98vh!important;
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 0px;
padding: 0px 0px 8px 24px;
background-color: #FFFFFF;
@media only screen and (min-width:0px) and (max-width:1100px){
  display:${(prop) => prop.params.id ? 'none' : 'flex'};
  width: -webkit-fill-available;
}
`;

export const ItemAux = styled.div`
flex-grow: 1;
color: #003049;
font-family: 'Montserrat', sans-serif;
font-weight: 600;
font-size: 10px;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
max-width:   180px;
@media only screen and (min-width: 0px) and (max-width: 800px) {
    width: 100%;
    max-width:   100%;
    font-size: 8px;
}
`
export const DivFlexColumn = styled.div`
background-color: rgba(255, 255, 255, 0.8);
width: -webkit-fill-available;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
padding: 16px;
max-height: 85vh;
min-height: 85vh;
overflow-y: auto;
border-radius: 8px;
margin-right: 16px;
margin-top: 8px;
justify-content: flex-start;

&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}

@media only screen and (min-width:0px) and (max-width:1100px){
  display:${(prop) => prop.params.id ? 'flex' : 'none'};
  margin-right: 0px;
}
`;

export const IconButton = styled.img`
max-width:20px;
max-height:20px;
width:20px;
height:20px;
cursor:pointer;
&:active{
  zoom: 95%;
}
`;

export const Input = styled.input`
box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
width: -webkit-fill-available;
min-width: -webkit-fill-available;
margin: 8px 8px;
padding:5px;
border:none;
outline: none;
background:#FFFFFF;
border-radius:8px;
height:26px;
min-height:26px;
max-width: 10vw;
font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #07082c;
&:placeholder{
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #07082c;
}
`;

export const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: 95vh;
max-height: 95vh;
overflow-y: hidden;
max-width: calc(100vw - 84px);
gap: 16px;
display: flex;
flex-direction: row;
align-items: flex-start;
margin: 1% 16px 0px 1%;
background-color:#FFFFFF;
border-radius:8px;
box-shadow: 
      0px 3.200000047683716px 7.199999809265137px 0px rgba(0, 48, 72, 0.12), 
      0px 0.6000000238418579px 1.7999999523162842px 0px rgba(0, 48, 72, 0.10);

@media only screen and (min-width:0px) and (max-width:1100px){
  margin: 5vh 0px 0px 0px;
  max-width: calc(100vw - 0px);
}
`;

export const DivRow = styled.div`
width: -webkit-fill-available;
display: flex;
flex-direction: row;
align-items: center;
gap: 16px;
padding: 0.5em 0em 0.5em;
justify-content: space-between;
`;

export const DivRow1 = styled.div`
width: auto;
display: flex;
flex-direction: row;
align-items: flex-start;
gap: 5px;
`;

export const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: calc(100vh - 31vh) !important;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
border-top: 2px solid #003049;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;


export const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 14px;
color: #003049;
`;

export const Text1 = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
font-weight: 600;
font-size: 18px;
color: #003049;
`;